<template>
  <div>
    <card class="w-100 info">
      <el-row :gutter="10">
          
          <el-col :span="3">
            <div class="mt-4">
              <el-button class="" type="" icon="el-icon-caret-left" v-on:click="goback">이전 목록으로 이동</el-button>
            </div>
          </el-col>

          <el-col :span="2">
            <el-card class="form-group">
              <label>권한</label>
              <div>{{companyInfo.roleName}}</div>
            </el-card>
          </el-col>

          <el-col :span="4">
            <el-card class="form-group">
              <label>업체명</label>
              <div>
              {{companyInfo.companyName}}
              </div>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card class="form-group">
              <label>ID/사업자번호</label>
              <div>
              {{companyInfo.licenseNumber}}
              </div>
            </el-card>
          </el-col>
          <el-col :span="2">
            <el-card class="form-group">
              <label>이름</label>
              <div>{{companyInfo.userName}}</div>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card class="form-group">
              <label>연락처</label>
              <div>&nbsp;{{companyInfo.phone1}}</div>
            </el-card>
          </el-col>
          <el-col :span="4">
            <el-card class="form-group">
              <label>이메일</label>
              <div>&nbsp;{{companyInfo.email}}</div>
            </el-card>
          </el-col>

          <el-col :span="3">
            <div class="mt-4">
              <el-button class="pull-right" type="primary" icon="el-icon-edit" v-on:click="editMasterUser">대표계정 수정</el-button>
            </div>
          </el-col>
      </el-row>
    </card>

    <card class="w-100">
      <el-row>
        <el-col :span="24">
          <el-button class="pull-right" type="primary" icon="el-icon-plus" v-on:click="insertSubUser">담당자계정 등록</el-button>
          <el-button  icon="el-icon-refresh" v-on:click="getSubUserList">새로고침</el-button>
        </el-col>
      </el-row>
      <el-col :span="24">
        <el-table class="table-striped"
                  border
                  ref="accountTable"
                  style="width: 100%; margin: 10px 0"
                  :data="items"
                  :header-cell-style="tableRowStyle">
          <el-table-column class="text-center"
            prop="masterYn" width="60px"
            label="상태">
            <template slot-scope="props">
              <div class="text-center" >
                <span v-if="props.row.status === 'READY'" class="text-danger">대기</span>
                <span v-if="props.row.status === 'OK'" class="text-success">승인</span>
                <span v-if="props.row.status === 'REMOVE'" class="text-danger">삭제</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="userId"
            label="아이디">
          </el-table-column>
          <el-table-column
            prop="department" 
            label="부서">
          </el-table-column>
          <el-table-column
            prop="userName"
            label="이름">
          </el-table-column>
          <el-table-column width="150"
            prop="phone1"
            label="연락처">
          </el-table-column>
          <el-table-column
            prop="email"
            label="이메일">
          </el-table-column>
          <el-table-column
            label="등록일"
            width="160">
            <template slot-scope="props">
              {{ props.row.regDate | moment('YYYY-MM-DD HH:mm')}}
            </template>
          </el-table-column>
          <el-table-column
            label="관리"
            align="center"
            width="70">
            <template slot-scope="props">
              <div class="text-center">

                <el-dropdown @command="menuClick" trigger="click">
                  <span class="el-dropdown-link">
                    <i class="el-icon-more"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">

                    <el-dropdown-item icon="el-icon-edit" :command="{command: 'edit-sub-user', row: props.row}"> 계정수정</el-dropdown-item>
                    <el-dropdown-item divided :command="{command: 'change-status', row: props.row, status:'OK', statusName:'가입승인'}" v-if="props.row.masterYn === 'N' && props.row.status === 'READY'" icon="el-icon-success"> 가입승인 처리</el-dropdown-item>

                    <el-dropdown-item :command="{command: 'reset-pwd', row: props.row}" divided v-if="props.row.masterYn === 'N'" icon="el-icon-lock"> 비밀번호 초기화</el-dropdown-item>

                  </el-dropdown-menu>
              </el-dropdown>
              </div>

            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24">
        <div class="pull-right">
          <el-button type="primary" icon="el-icon-plus" v-on:click="insertSubUser">담당자계정 등록</el-button>
        </div>
      </el-col>
    </card>
  </div>

</template>

<script>
  import Vue from 'vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import SettingsAccountEditSubUserModal from './SettingsAccountEditSubUserModal.vue'
  import CommonProxy from '@/proxies/CommonProxy'
import AccountsProxy from '@/proxies/AccountsProxy'
import CompanyProxy from '@/proxies/CompanyProxy'
import UserProxy from '@/proxies/UserProxy'


  export default {
    name: "SettingsAccount",
    components: {
      PPagination
    },
    created: function () {

      this.beforeParams = {...this.$route.params}

      this.companySeq = this.$route.params.companySeq

      this.getSubUserList()
      

    },
    updated: function () {
      this.$refs.accountTable.doLayout();
    },
    methods: {
      goback() {
        this.$router.push({
          name: 'SettingsAccount',
          params: this.beforeParams
        })
      },
      editMasterUser() {
        const params = {...this.beforeParams, userId: this.companyInfo.userId, returnName: 'SettingsAccountSubUserList' }
        this.$router.push({name: 'SettingsAccountEdit', params });

      },
      tableRowStyle() {
        return this.$store.state.common.tableHeaderCellStyle;
      },
      // 드롭다운 메뉴클릭
      menuClick( {command, row, status, statusName} ) {

        switch(command) {
          case 'edit-sub-user':  this.editSubUser( row ); break
          case 'reset-pwd' : this.resetPwd( row ); break
          case 'change-status' : {
            if(!confirm(`${statusName} 처리 하시겠습니까?`)) return
            this.changeUserStatus( row.userId, status )
            .then(()=>alert(`${statusName} 처리 되었습니다.`))
            break
          }  
        }

      },
      // 상태변경
      changeUserStatus( userId, status ) {

        new AccountsProxy()
        .changeUserStatus( userId, status)
        .then(res => {
          const account = this.items.find(item=>item.userId === userId)
          if(account) {
              this.items.splice(this.items.indexOf(account), 1, {...account, status})
          }  
        })


      },
      // 대표수정
      handleEdit({ userId }) {
        
        const params = {...this.search, userId: userId, scroll: window.scrollY }
        this.$router.push({name: 'SettingsAccountEdit', params });
        
      },
      // 담당자 수정
      editSubUser({ userId }) {

        this.$modal.show(
          SettingsAccountEditSubUserModal,
          { changeRecord: this.changeRecord, mode: 'edit', userId  },
          { width:'780px' },
          {}
        )

      },
      // 담당자 추가
      insertSubUser() {

        this.$modal.show(
          SettingsAccountEditSubUserModal,
          { changeRecord: this.refreshItems, mode: 'insert', companyInfo: this.companyInfo },
          { width:'780px' },
          {}
        )

      },
      changeRecord( newItem ) {

        const account = this.items.find(item=>item.userId === newItem.userId)
        if(account) {
          if(newItem.status === 'REMOVE') {
              this.items.splice(this.items.indexOf(account), 1)
          } else {
              this.items.splice(this.items.indexOf(account), 1, {...account, ...newItem})
          }  
        }          
        
      },
        // 담당자 계정 리스트
      refreshItems() {
        new AccountsProxy().getSubUserList( this.companySeq )
        .then(response => this.items = response.items )
      },
      getSubUserList() {

        // 담당자 계정 리스트
        this.refreshItems()

        // 회사 정보
        new AccountsProxy().getMasterUser( this.companySeq )
        .then(response => {
          this.companyInfo = {...response.item}
          this.$store.dispatch('common/setMenuTitle', this.companyInfo.companyName+" 담당자계정 관리");

        })

      },
      // 초기화
      resetPwd( {userId} ) {
        if(!confirm('비밀번호를 초기화 하시겠습니까?\n\n사용자의 이메일로 비밀번호초기화 안내 메일이 발송됩니다.')) {
          return
        }  
        new CommonProxy()
          .resetPwdByAdmin( userId )
          .then(response => {
            if(!response.success) {
              if(!response.found) {
                alert('해당하는 사용자를 찾을 수 없습니다.')
              } else if(!response.email) {
                alert('이메일이 없는 사용자 입니다.')
              }  

            } else {
              alert('사용자의 이메일로 비밀번호초기화 안내메일을 전송했습니다.')
            }
        })

      }

    },
    computed: {
    },
    data() {
      return {
        items: [],
        companyInfo: {},
      }
    }
  }
</script>

<style scoped>
.card.info .card.form-group { margin-bottom: 10px;}
.card.form-group .el-card__body { padding: 12px;}
</style>
